import TraceJournalLink from './TraceJournalLink';

export default TraceJournalLink;
